/* eslint-disable no-unused-vars */

import { getValue } from 'firebase/remote-config';
import { remoteConfig } from '../apis/firebase';

/**
 * Keys for Firebase Remote Config keys.
 * Can be used when calling {@link remoteConfig}'s `getValue()`
 *
 * @enum {string}
 */
const RemoteConfigKeys = {
  ExmapleKey: 'EXAMPLE_KEY',
  PermanentRecruiterIds: 'PERMANENT_RECRUITER_IDS',
  OnsiteInterviewThresholdInMinutes: 'ONSITE_INTERVIEW_THRESHOLD_MINUTES',
};

/**
 * Utility object for accessing Firebase Remote Config values.
 * Provides type-safe methods to retrieve various configuration parameters.
 */
export const RemoteConfigUtils = {
  getExample: () => getValue(remoteConfig, RemoteConfigKeys.ExmapleKey).asNumber(),

  getPermanentRecruiterIds: () =>
    getValue(remoteConfig, RemoteConfigKeys.PermanentRecruiterIds).asString()?.split(','),

  getOnsiteInterviewThresholdInMinutes: () =>
    getValue(remoteConfig, RemoteConfigKeys.OnsiteInterviewThresholdInMinutes).asNumber(),
};
